import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import ProjetoCulturalService from '../../../../../services/projetoCultural-auth';
import { Link, useParams, Navigate } from 'react-router-dom';
import Moment from 'moment';

const Projeto = () => {
    let { id } = useParams()

    const [patrocinador, setPatrocinador] = useState("");
    const [valor, setValor] = useState("");
    const [beneficiario, setBeneficiario] = useState("");
    const [dataCap, setDataCap] = useState("");
    const [andamento, setAndamento] = useState("");
    const [prazo, setPrazo] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchProjeto(id) {
        const response = await ProjetoCulturalService.projetoCulturalEdit(id);
        setPatrocinador(response.data["patrocinador"]);
        setValor(response.data["valor"]);
        setBeneficiario(response.data["beneficiario"]);
        setDataCap(Moment(response.data["dataCap"]).utc(false).format("yyyy-MM-DD"));
        setAndamento(response.data["andamento"]);
        setPrazo(response.data["prazo"]);
    }

    useEffect(() => {
        fetchProjeto(id);
    }, [id]);

    const ponto = (campo) => {
        return campo.replace(/,/g, ".");
    }


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const projeto = await ProjetoCulturalService.editar(id, {
                patrocinador: patrocinador,
                valor: valor,
                beneficiario: beneficiario,
                dataCap: dataCap,
                andamento: andamento,
                prazo: prazo
            })
            if (projeto.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="patrocinador">
                                <FloatingLabel
                                    label="Patrocinador/Doador"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="patrocinador"
                                        value={patrocinador}
                                        onChange={e => setPatrocinador(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Valor Captado">
                                <FloatingLabel
                                    label="Valor Captado"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(ponto(e.target.value))} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="beneficiario">
                                <FloatingLabel
                                    label="Beneficiario"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="beneficiario"
                                        value={beneficiario}
                                        onChange={e => setBeneficiario(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Andamento do Projeto">
                                <FloatingLabel
                                    label="Andamento do Projeto"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Andamento do Projeto"
                                        name="andamento"
                                        onChange={e => setAndamento(e.target.value)}
                                    >
                                        <option value={andamento}>{andamento}</option>
                                        <option value="Em Andamento">Em Andamento</option>
                                        <option value="Recursos Captados">Recursos Captados</option>
                                        <option value="Concluído">Concluído</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Prazo Final">
                                <FloatingLabel
                                    label="Prazo Final"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="prazo"
                                        value={prazo}
                                        onChange={e => setPrazo(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/renuncias/projetocultural/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Projeto Cultural editado com sucesso!</Alert>
                <Navigate to={'/restrito/projetocultural/listar'} />
            </Fragment>
        )
    }
}

export default Projeto;